//서버와 통신하는 enum을 만든다.
//ASK = request, REP = response
//request 대신 ask를 쓴 이유는 req, rep가 끝 한 글자 차이라 오타가 날까봐.
let AiccWsSessionDataType = {
    "StartAsk": 100,
    "StartRep": 101,
    "EndAsk": 102,
    "EndRep": 103,

    "ModifyScheduleStartAsk": 11,
    "ModifyScheduleStartRep": 12,

    "Ping" : 200,		// 클라이언트가 일정 간격으로 서버로 ping을 보내고
    "Pong" : 201,		// 서버가 ping 응답으로 pong을 보낸다.

};

let AiccWsSession = function() {
    // 생성자에서 멤버 변수를 초기화한다.
    this.connected = false;
    this.socket = null;

    this.handlerMap = new Map();

    this.connectHandler = null; // websocket 연결되는 처리하는 핸들러
    this.closeHandler = null; // websocket 연결 끊어지면 처리하는 핸들러
    this.errorHandler = null; // websocket 에러 발생하면 처리하는 핸들러

    this.pingCounter = 0,	// ping 횟수, ping 보낼 때마다 1씩 증가한다. pong을 받으면 0으로 바꾼다.
	this.doPing = true,
	this.pingTimer = -1,
	this.pingInterval = 20 * 1000,	// 밀리초단위. 20초. AWS 로드밸런서 Idle timeout이 1분이라서 1분 미만으로 설정해야 한다.
	this.pingMaxCount = 10; 	// ping 최대 재시도 횟수
};

/**
 * 연결된 websocket으로 object를 json으로 바꾸어서 보낸다.
 */
AiccWsSession.prototype.sendObj = function(obj) {
    if (obj === null || obj === undefined || obj === "") {
        console.warn("object to be sent is " + obj);
        return -1;
    }

    if (!this.connected) {
        console.warn("not connected. can't send object");
        return -1;
    }

    var jsonStr = JSON.stringify(obj);
    //console.log("obj : " + jsonStr);

    try {
        this.socket.send(jsonStr);
    } catch (ex) {
        console.warn(ex);
    }

    return jsonStr.length;
};


AiccWsSession.prototype.isFunction = function(handler) {
    if (handler === null || typeof handler === 'function') {
        // null로 설정할 수도 있으므로 null도 받아들인다
        return true;
    }

    return false;
};


/**
 * 메시지를 처리할 메시지 핸들러를 설정한다.
 * msgName : xxxRep과 같이 서버에서 온 메시지 이름.
 * handler : 메시지 핸들러 함수
 */
AiccWsSession.prototype.setHandler = function(msgName, handler) {
    if (msgName !== null && msgName !== undefined && msgName.length > 0 && this.isFunction(handler)) {
        this.handlerMap.set(msgName, handler);
    }
};


/**
 * websocket 연결되면 호출된다.
 */
AiccWsSession.prototype.setConnectHandler = function(handler) {
    // handler가 null이 아니면서 function일 때만 대입한다.
    // 핸들러를 초기화할 때도 이 함수를 쓸 수 있기 때문에 null을 받아들인다.
    if (this.isFunction(handler)) {
        this.connectHandler = handler;
    }
};

/**
 * websocket 연결 끊기면 호출된다.
 */
AiccWsSession.prototype.setCloseHandler = function(handler) {
    if (this.isFunction(handler)) {
        this.closeHandler = handler;
    }
};

/**
 * websocket 에러 발생하면 호출된다.
 */
 AiccWsSession.prototype.setErrorHandler = function(handler) {
    if (this.isFunction(handler)) {
        this.errorHandler = handler;
    }
};

/**
 * 서버와 연결한다.
 * 연결된 상태에서 이 함수를 호출하면 이전 연결은 끊기고 새로 연결한다.
 * 왜냐하면 WebSocket을 새로 만들어서 this.socket에 할당하면 이전 값은 없어지고(=연결이 끊기고) 새로 연결된다.
 */
AiccWsSession.prototype.connect = function(host) {
    if ('WebSocket' in window) {
        this.socket = new WebSocket(host);
    } else if ('MozWebSocket' in window) {
        this.socket = new MozWebSocket(host);
    } else {
        console.warn("Error: WebSocket is not supported by this browser.");
        return -1;
    }

    // socket의 owner를 이 클래스로 지정해서 socket 이벤트 처리할 때 쓴다.
    this.socket.owner = this;

    // 참고!!!!
    // onopen, onclose, onmessage에 지정된 function이 호출될 당시에 this는 WebSocket이다.
    // 그래서 owner에 이 클래스를 지정하고 onopen, onclose, onmessage 핸들러 안에서는 "this.owner.멤버"로 접근한다.

    this.socket.onopen = function() {
        console.log('Socket onopen');
        //console.log(this);		// this는 WebSocket 객체이다.

        this.owner.connected = true;

        // callback을 지정했으면 호출한다.
        if (typeof this.owner.connectHandler === 'function') {
            this.owner.connectHandler();
        }

        this.owner.handlerMap.set("Pong", this.owner.onPong);
		this.owner.startPing();	
    };

    this.socket.onclose = function(evt) {
        // console.log('socket.onclose', evt);

        this.owner.connected = false;

        // callback을 지정했으면 호출한다.
        if (typeof this.owner.closeHandler === 'function') {
            this.owner.closeHandler();
        }
    };

    this.socket.onmessage = function(msg) {
        // console.log("socket.onmessage");
        // console.dir(msg.data);

        var jsonData = JSON.parse(msg.data);

        // console.log(jsonData);

        // dataName(...Rep 등)을 처리하는 핸들러를 찾는다
        var handler = this.owner.handlerMap.get(jsonData.dataName);

        if (typeof handler === 'function') {
            handler(jsonData, this.owner);
        }
    };

    this.socket.onerror = function(err) {
        console.warn("Socket error", err);
        // callback을 지정했으면 호출한다.
        if (typeof this.owner.errorHandler === 'function') {
            this.owner.errorHandler();
        }
    };

    return 0;
};


/**
 * 서버와의 연결을 끊는다.
 */
AiccWsSession.prototype.disconnect = function() {
    this.stopPing();
    this.socket.close();
};

AiccWsSession.prototype.startModifySchedule = function(scheduleId) {
    console.log("startModifySchedule");
    var obj = new Object();
    obj.dataType = AiccWsSessionDataType.ModifyScheduleStartAsk;
    obj.msg = "ModifyScheduleStartAsk";
    obj.scheduleId = scheduleId;
    this.sendObj(obj);
    return 0;
};

AiccWsSession.prototype.startPing = function() {
	console.log("startPing");

	this.doPing = true;
	if(this.pingTimer !== -1) {
		clearTimeout(this.pingTimer);
	}
	
	var that = this;
	this.pingTimer = setTimeout(function() { that.sendPing(); }, that.pingInterval);
}

AiccWsSession.prototype.stopPing = function() {
	console.log("stopPing");
	
	this.doPing = false;
	if(this.pingTimer !== -1) {
		clearTimeout(this.pingTimer);
		this.pingTimer = -1;
	}
}

AiccWsSession.prototype.sendPing = function() {
    console.log("sendPing");

	if(!this.doPing) {	
		return;
	}

	this.pingCounter++;
	if(this.pingCounter > this.pingMaxCount) {
		console.log("pingCounter " + this.pingCounter + " exceed max ping count " + this.pingMaxCount);
		this.disconnect();
		console.warn("서버에서 응답이 없어 연결을 끊었습니다.");
        this.socket.onerror();
		return;
	}
	
	var obj = new Object();
	obj.dataType = AiccWsSessionDataType.Ping;
	obj.msg = "Ping";
    // console.log(obj)
	this.sendObj(obj);
	var that = this;
	this.pingTimer = setTimeout(function() { that.sendPing(); }, that.pingInterval);
}

/**
 * 서버에서 PONG을 받았다.
 */
 AiccWsSession.prototype.onPong = function(data, thisAiccSession) {
	thisAiccSession.pingCounter = 0;	
    // console.log(data)
	if(data.reply.code === "0000") {
		// pong이 왔고 오류가 없는 경우
	}
	else {
		console.log(data.reply);
		this.stopPing();
		this.disconnect();
		console.warn("서버 오류가 발생하여 서버 연결을 종료합니다.");
        this.socket.onerror();
	}
}

export default AiccWsSession;